import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import { schedulingTask } from 'src/redux/actions/constant';
import therapistService from 'src/services/apiServices/therapist-scheduling/therapistService';

const {
  CREATE_TASK_NOTE_SCHEDULING_REQUEST,
  CREATE_TASK_NOTE_SCHEDULING_SUCCESS,
  CREATE_TASK_NOTE_SCHEDULING_FAILURE,
  CREATE_TASK_NOTE_SCHEDULING_LOADING,
  CREATE_TASK_NOTE_SCHEDULING_RESET,
} = schedulingTask;

function* createSchedularTaskNote(action: any): SagaReturnType<any> {
  try {
    yield put({ type: CREATE_TASK_NOTE_SCHEDULING_LOADING });
    const response = yield call(therapistService.createTherapistTaskNote, action.payload);
    if (response?.status === 200) {
      yield put({ type: CREATE_TASK_NOTE_SCHEDULING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_TASK_NOTE_SCHEDULING_FAILURE, payload: error });
  }
}

function* createSchedularTaskNoteSaga() {
  yield takeEvery(CREATE_TASK_NOTE_SCHEDULING_REQUEST, createSchedularTaskNote);
}

export default createSchedularTaskNoteSaga;
